import React from "react";
import Typewriter from "typewriter-effect";
import { HiArrowDown, HiDownload } from "react-icons/hi";
import { personalInfo } from "../../data";
import { useCountUp } from "../../hooks/useCountUp";

const STATS = [
  { target: 5, suffix: "+", label: "Years experience" },
  { target: 20, suffix: "+", label: "Projects delivered" },
  { target: 6, suffix: "+", label: "Industries served" },
  { target: 1, suffix: "K+", label: "TPS at scale" },
];

function StatItem({ target, suffix, label }) {
  const [count, ref] = useCountUp(target);
  return (
    <div className="hero-stat-item" ref={ref}>
      <span className="hero-stat-number">{count}{suffix}</span>
      <span className="hero-stat-label">{label}</span>
    </div>
  );
}

function Hero() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-bg" />
      <div className="hero-grid-overlay" />

      <div className="hero-inner">
        <h1 className="hero-name">{personalInfo.name}</h1>

        <div className="hero-typewriter-row">
          <span className="hero-typewriter-label">I'm a</span>
          <div className="hero-typewriter-text">
            <Typewriter
              options={{
                strings: personalInfo.roles,
                autoStart: true,
                loop: true,
                deleteSpeed: 40,
                delay: 55,
              }}
            />
          </div>
        </div>

        <p className="hero-bio">{personalInfo.bio}</p>

        <div className="hero-actions">
          <a href="#projects" className="btn-primary">
            View My Work <HiArrowDown style={{ fontSize: "0.85rem" }} />
          </a>
          <a href="#contact" className="btn-secondary">
            Get In Touch
          </a>
          <a href={personalInfo.resumeLink} download className="btn-outline">
            <HiDownload style={{ fontSize: "0.9rem" }} /> CV
          </a>
        </div>

        <div className="hero-stats">
          {STATS.map((stat) => (
            <StatItem key={stat.label} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero;
